module.exports = __webpack_public_path__ + "img/klaytn.135a5e22.svg";